/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-14 11:43:22
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-24 14:02:51
 */
import { Tooltip } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import {
  BoyOutfillIcon,
  GirlOutfillIcon,
} from '../../../../compnents/icons/Icons'
import styles from './unexecutedPrescription.module.css'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import moment from 'moment'
import { DateTimeFormatSimple, DateTimeFormatSimplePrintCharge } from '../../../../models/datetime'

interface ListItemProps {
  selectId: any
  data?: any
  index?: string
  onClick?: (el: any) => void
}

export const ListItem = ({
  data = {},
  selectId,
  index,
  onClick,
}: ListItemProps): ReactElement => {
  const [patientInfo, setPatientInfo] = useState<any>({})

  const dispatch = useDispatch<RootDispatch>()

  useEffect(() => {
    data.patient && setPatientInfo(data.patient)
  }, [data])

  return (
    <>
      <div
        className={styles.listItem}
        style={{
          backgroundColor: selectId == data?.id ? 'rgb(241 246 255)' : '',
          borderRadius: selectId == data?.id ? '4px' : '',
        }}
        onClick={(e) => {
          onClick && onClick(data)
        }}
      >

        <div className={styles.cell}>
          <div className={styles.left}>
            <div style={{ width: '26px', textAlign: 'center' }}>
              {data.patientSex == 2 ? (
                <GirlOutfillIcon
                  style={{
                    color: "#FF8181",
                    width: 18,
                    height: 18,
                  }}
                />
              ) : <BoyOutfillIcon
                style={{
                  color: "#77A1FF",
                  width: 18,
                  height: 18,
                }}
              />}
            </div>
            <Tooltip
              placement="topLeft"
              title={data.patientName}
              arrowPointAtCenter
            >
              <div className={styles.name}>{data.patientName}</div>
            </Tooltip>
          </div>
          <div className={styles.right}>
            {
              (() => {
                if (!data?.recentlyTime) return null;
                const today = new Date();
                const timeDate = new Date(data.recentlyTime);
                const isToday = timeDate.toDateString() === today.toDateString();
                return isToday
                  ? `${timeDate.getHours().toString().padStart(2, '0')}:${timeDate.getMinutes().toString().padStart(2, '0')}`
                  : (data.recentlyTime ? moment(data.recentlyTime).format(DateTimeFormatSimplePrintCharge) : '');
              })()
            }
          </div>
        </div>
        <div className={styles.detail}>
          {data.disease || '-'}
        </div>
      </div>
    </>
  );
}
